<ng-template [cxOutlet]="StorefrontOutlets.STOREFRONT" cxPageTemplateStyle>
  <app-skip-link />

  <header #header class="container" [cxFocus]="{ disableMouseFocus: true }">
    <app-header *ngIf="!isCheckout" [isOrderConfirmation]="isOrderConfirmation"></app-header>
    <app-checkout-header *ngIf="isCheckout"></app-checkout-header>
    <app-global-message></app-global-message>
  </header>

  <main cxSkipLink="cx-main" [cxFocus]="{ disableMouseFocus: true }" class="container my-5 my-sm-8">
    <router-outlet></router-outlet>
  </main>

  @defer {
    <footer
      [cxFocus]="{ disableMouseFocus: true }"
      class="pt-12"
      [ngClass]="isCheckout ? 'footer-checkout' : ''"
    >
      <cx-page-layout section="footer">
        <div class="container">
          <app-footer *ngIf="!isCheckout"></app-footer>
          <app-checkout-footer *ngIf="isCheckout"></app-checkout-footer>
        </div>
      </cx-page-layout>
    </footer>
  }
  <haba-pro-login-modal></haba-pro-login-modal>
</ng-template>
